import { useEffect } from "react";
import privacyContent from "../../data/privacyContent";

const Privacy = () => {
    useEffect(() => {
        document.title = "Datenschutz | Casaantonio e piccolo gió";
    }, []);
    return (
        <main className="terms">
            <h2>Datenschutzerklärung</h2>
            <p>
                Diese Datenschutzerklärung ("Erklärung") erläutert, wie Casaantonio e piccolo gió ("Casaantonio e piccolo gió", "wir", "uns" oder "unser") Ihre personenbezogenen Daten erhebt, verwendet und schützt, wenn Sie unseren Newsletter abonnieren.
                Mit Ihrer Anmeldung stimmen Sie ("Sie", "Ihr" oder "Nutzer") den in dieser Erklärung beschriebenen Praktiken zu.
            </p>
            {privacyContent.map((content) =>
                <section key={content.title}>
                    <h3>{content.id}. {content.title}:</h3>
                    <p>{content.content}</p>
                </section>)}
                <p>
                    Wenn Sie Fragen oder Bedenken zu unserer Datenschutzerklärung haben, können Sie uns gerne unter 
                    <a href="mailto:casa.itzling@gmail.com"> casa.itzling@gmail.com</a>. 
                    <br />
                    🍕 Vielen Dank, dass Sie Teil von Casaantonio e piccolo gió sind!
                    </p>
        </main>
    )
}

export default Privacy;